import { cn } from "@patient-watch/ui/utils";
import type { CalendarDay } from "../utils/calendarHelpers";

interface CalendarDayProps {
    day: CalendarDay;
    hasEntry: boolean;
    isSubmitted: boolean;
    isSelected: boolean;
    onSelect: () => void;
}

export function CalendarDayComponent({ day, hasEntry, isSubmitted, isSelected, onSelect }: CalendarDayProps) {
    return (
        <button
            type="button"
            onClick={onSelect}
            disabled={!day.isCurrentMonth}
            className={cn(
                "relative flex flex-col justify-center items-center p-2 rounded-lg aspect-square transition-all",
                "hover:bg-slate-100 active:scale-95",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-300 focus-visible:ring-offset-2",
                day.isCurrentMonth ? "text-slate-900" : "text-slate-300",
                isSelected && "bg-blue-50 ring-2 ring-indigo-300 ring-offset-2",
                !day.isCurrentMonth && "cursor-not-allowed opacity-50",
                hasEntry && isSubmitted && "bg-green-50",
                hasEntry && !isSubmitted && "bg-amber-50"
            )}
        >
            <span
                className={cn(
                    "mb-1 text-md text-slate-800",
                    day.isToday && isSubmitted && "text-green-700",
                    day.isToday && !isSubmitted && "text-amber-700"
                )}
            >
                {day.dayNumber}
            </span>
            {hasEntry && (
                <div className="bottom-1 absolute">
                    <div className={cn("rounded-full w-2 h-2", isSubmitted ? "bg-green-600" : "bg-amber-600")} />
                </div>
            )}
        </button>
    );
}
